import React, { useEffect, useState } from 'react';
import { Container, Nav, Spinner } from 'react-bootstrap';
import { NavLink, Outlet } from 'react-router-dom';
import { FaBook, FaDatabase, FaFileAlt, FaLayerGroup, FaRobot } from 'react-icons/fa';
import { fetchAiChatbotIndexingOptions } from '../../../utils/aiChatbotIndexingMode';
import './AiChatbotSetupLayout.css';

const AiChatbotSetupLayout = () => {
  const [options, setOptions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const opts = await fetchAiChatbotIndexingOptions();
        if (active) setOptions(opts);
      } catch {
        if (active) setOptions({ canIndexStandard: false, canIndexCustom: false, canAccessSetup: false });
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return (
    <Container fluid className="p-4 ai-chatbot-setup-layout">
      <div className="d-flex align-items-center mb-3">
        <FaRobot className="me-2 text-primary" size={22} />
        <h4 className="mb-0">AI Chatbot</h4>
      </div>

      <Nav variant="pills" className="ai-chatbot-setup-nav mb-4 flex-wrap">
        <Nav.Item>
          <Nav.Link as={NavLink} to="/setup/aichatbot" end>
            Overview
          </Nav.Link>
        </Nav.Item>
        {!loading && options?.canIndexStandard && (
          <Nav.Item>
            <Nav.Link as={NavLink} to="/setup/aichatbot/schema/standard">
              <FaLayerGroup className="me-1" />
              Standard Schema
            </Nav.Link>
          </Nav.Item>
        )}
        {!loading && options?.canIndexCustom && (
          <Nav.Item>
            <Nav.Link as={NavLink} to="/setup/aichatbot/schema/custom">
              <FaDatabase className="me-1" />
              Custom Schema
            </Nav.Link>
          </Nav.Item>
        )}
        {!loading && options?.canIndexStandard && (
          <Nav.Item>
            <Nav.Link as={NavLink} to="/setup/aichatbot/prompts">
              <FaFileAlt className="me-1" />
              Platform Prompts
            </Nav.Link>
          </Nav.Item>
        )}
        {!loading && options?.canAccessSetup !== false && (
          <Nav.Item>
            <Nav.Link as={NavLink} to="/setup/aichatbot/schema-prompts">
              <FaFileAlt className="me-1" />
              Schema Prompts
            </Nav.Link>
          </Nav.Item>
        )}
        {loading && (
          <Nav.Item className="d-flex align-items-center px-2">
            <Spinner animation="border" size="sm" />
          </Nav.Item>
        )}
        <Nav.Item>
          <Nav.Link as={NavLink} to="/setup/aichatbot/dictionary">
            <FaBook className="me-1" />
            Manage AI Dictionary
          </Nav.Link>
        </Nav.Item>
      </Nav>

      <Outlet />
    </Container>
  );
};

export default AiChatbotSetupLayout;
